export const StorageKeys = {
  TENANT_NAME: 'tenant-name',
  KIOSK_CODE: 'kiosk-code',
  READER_ID: 'readerId',
  DEVICE_CODE: 'deviceCode',
  CONFIGURED_LOCATION_ID: 'configuredLocationId',
  MYPOS_TERMINAL_NAME: 'mypos-terminal-name',
  MYPOS_TERMINAL_ADDRESS: 'mypos-terminal-address',
  MYPOS_TERMINAL_CONNECTION_TYPE: 'mypos-terminal-connection-type',
  CONFIRMED_ORDER_HANDOFF: 'confirmed-order-handoff-v1',
  CASH_ORDER_OPERATION: 'cash-order-operation-v1',
  PRINT_OUTBOX: 'print-outbox-v1',
  
  BASIC_INFO: 'basic-info',
  STORE: 'store',
  PRINTERS: 'printers',
  LANG: 'lang',
  CUSTOM_THEME: 'custom-theme',
  LIGHT_DARK_MODE: 'light-dark-mode',
} as const;

export const DURABLE_STORAGE_KEYS = [
  StorageKeys.CASH_ORDER_OPERATION,
  StorageKeys.PRINT_OUTBOX,
  StorageKeys.CONFIRMED_ORDER_HANDOFF,
] as const;

export const SECURE_KEYS = [
  StorageKeys.TENANT_NAME,
  StorageKeys.KIOSK_CODE,
  StorageKeys.READER_ID,
  StorageKeys.DEVICE_CODE,
  StorageKeys.CONFIGURED_LOCATION_ID,
  StorageKeys.MYPOS_TERMINAL_NAME,
  StorageKeys.MYPOS_TERMINAL_ADDRESS,
  StorageKeys.MYPOS_TERMINAL_CONNECTION_TYPE,
] as const;




